import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ExcelService } from 'src/app/service/excel.service'
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { AddReasonIdComponent } from 'src/app/core/dialogs/add-reason-id/add-reason-id.component';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { ReasonidService } from 'src/app/service/reasonid.service';

@Component({
    selector: 'app-reason-id',
    templateUrl: './reason-id.component.html',
    styleUrls: ['./reason-id.component.scss'],
    standalone: false
})
export class reasonIdComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  categoryDrpDown: any[];
  isAccessible: boolean;
totalRecords = 0; 
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
    {value: 20 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;
  paginationPageSize: number = 30;
  dynamicHeight: number;
  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService,
    private readonly eboiStateService: EboiStateService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly reasonIdService: ReasonidService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }

    this.gridOptions = {
			suppressCellSelection: true,
			context: this.context,
		  }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles() 
    this.columnDefs = [
      {
        headerName: "Reason ID", field: "reasonId", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 40, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Reason Name", field: "description", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 160, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Category", field: "category", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 60,
      },
      {
        headerName: "Include In Investigation", field: "includeInvestigation", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 100, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Include In All", field: "includeInAll", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 60, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Actions", field: "reasonId_editdelete", cellRenderer : BtnCellRendererEditDelete,
        width: 60
      },
    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.refreshData();
    this.categoryIdDropdown();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // } // Commented for APM integration
  }

  async categoryIdDropdown() {
    await this.reasonIdService.loadCategoryIdDropDown().then(x => {

      if (x && x.length > 0) {
        this.categoryDrpDown = [];
        x.forEach(element => {
          this.categoryDrpDown.push({ label: element.categoryId, value: element.description })
        });
      }
    })
  }




  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.totalRecords = this.displayRowData.length;
    
  }

  

  refreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.reasonIdService.loadReasonId().subscribe(
      response => {
        this.displayRowData = response
        this.totalRecords = this.displayRowData.length;
        this.displayRowData.forEach(element => {
          if (element.includeInvestigation == 1) { element.includeInvestigation = 'Y' } // NOSONAR
          else { element.includeInvestigation = 'N' }
          if (element.includeInAll == 1) { element.includeInAll = 'Y' } // NOSONAR
          else { element.includeInAll = 'N' }
        });
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.totalRecords = this.displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          setTimeout(() => {
          this.updatePaginationDetails();
        });
      },
      error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeleteDialogComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'Are you sure you want to delete this Reason ID?',
        description: " Reason ID : " + data.reasonId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == "ConfirmEvent") { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.reasonIdService.deleteReasonId(data.reasonId).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.refreshData();
            }

          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          })
      }
    }
    );
  }

  editTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      AddReasonIdComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'EDIT REASON ID',
        eventType: 'EDIT',
        reasonId: data.reasonId,
        reasonName: data.description,
        //categoryId: data.categoryId,
        includeInInvestigation: data.includeInvestigation,
        includeInAll: data.includeInAll,
        categoryId: data.category,
        categoryDrop: this.categoryDrpDown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }

  addReasonId() {
    const dialogRef = this.dialog.open(
      AddReasonIdComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'ADD REASON ID',
        eventType: 'ADD',
        categoryDrop: this.categoryDrpDown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }

 

  onBtExport() {
    if (this.displayRowData) {
      if (this.displayRowData.length > 0) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            reasonId: e.reasonId,
            reasonName: e.description,
            category: e.category,
            includeInInvestigation: e.includeInvestigation,
            includeInAll: e.includeInAll,
          };
          exportData.push(obj);
        });

        const headers = ['Reason IDs', 'Reason Name', 'Category', 'Include InInvestigation', 'Include In All',];
        this.excelService.exportAsExcelFile(exportData, 'REASON IDS', headers);
      }
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
    this.updatePaginationDetails();
  }

  goToLastPage() {
    this.gridApi.paginationGoToLastPage();
    this.updatePaginationDetails();
  }

  goToNextPage() {
    this.gridApi.paginationGoToNextPage();
    this.updatePaginationDetails();
  }

  goToPreviousPage() {
    this.gridApi.paginationGoToPreviousPage();
    this.updatePaginationDetails();
  }

  onPageSizeChanged(event: any) {
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }
  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();

      this.sRecord =
        this.gridApi.paginationGetPageSize() *
          this.gridApi.paginationGetCurrentPage() +
        1;
      this.eRecord =
        this.gridApi.paginationGetPageSize() *
          this.gridApi.paginationGetCurrentPage() +
        this.gridApi.paginationGetPageSize();
    //  this.totalRecords = this.gridApi.paginationGetRowCount();
      this.totalRecords = this.gridApi.paginationGetRowCount() || this.totalRecords;
      this.eRecord =
        this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }
  getCurrentPage(): boolean {
    if (this.cPage == 1) {
      // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.currentPageForTotalPage = Number(this.cPage);
    if (this.tPage == this.currentPageForTotalPage) {
      // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }
}

